import React from 'react';

type Props = {
  code?: string | null;
  title?: string | null;
  color?: string | null;
};

/** Бейдж источника товара (wb / ozon / manual / …). */
const SourceBadge: React.FC<Props> = ({ code, title, color }) => {
  const label = title || code || 'wb';
  const bg = color || '#6c757d';
  return (
    <span
      className="badge rounded-pill"
      style={{
        backgroundColor: bg,
        color: '#fff',
        fontSize: '0.65rem',
        fontWeight: 600,
        verticalAlign: 'middle',
      }}
      title={code || label}
    >
      {label}
    </span>
  );
};

export function productHref(product: {
  url?: string | null;
  source_code?: string | null;
  id: string | number;
}): string | undefined {
  if (product.url) return product.url;
  if ((product.source_code || 'wb') === 'wb') {
    return `https://www.wildberries.ru/catalog/${product.id}/detail.aspx`;
  }
  return undefined;
}

export default SourceBadge;
